import { combineReducers } from '@reduxjs/toolkit';
import { saleSetReducer } from './saleSetReducer';

export default combineReducers({
    saleSet: saleSetReducer
});
